import React from 'react';
import StorefrontOrdersTable from '../../components/Storefront/Orders/StorefrontOrdersTable';

const StorefrontOrdersPage: React.FC = () => {
    return (
        <div className='main-content'>
            <h1>Storefront Orders</h1>
            <StorefrontOrdersTable />
        </div>
    );
};

export default StorefrontOrdersPage;
